var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.getHideExpandBtn())?_c('div',{staticClass:"collapse-btn",class:{expand: _vm.expand},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_c('div',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.expand ? '收起' : '展开'))]),_vm._v(" "),_c('div',{staticClass:"arrow-icon"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef8a154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/collapse/collapse-btn.vue
// module id = null
// module chunks = 